import { useTheme } from '@mui/material/styles';
import { Text, TextProps } from 'components/Text';

interface Props extends TextProps {
  crossed?: boolean;
}
export const LightGrayLabel = ({ crossed, sx, ...rest }: Props) => {
  const theme = useTheme();

  return (
    <Text
      {...rest}
      sx={{
        // Rebrand: muted labels read as ink, not light gray.
        color: theme.palette.text.primary,
        textDecoration: crossed ? 'line-through' : 'none',
        ...sx
      }}
    />
  );
};
